// Import all translation files
import enUS from './en-US.json';
import enGB from './en-GB.json';
import nl from './nl.json';
import de from './de.json';
import fr from './fr.json';
import es from './es.json';
import it from './it.json';
import ar from './ar.json';

// Combine all translations
const translations = {
  "en-US": enUS,
  "en-GB": enGB,
  "nl": nl,
  "de": de,
  "fr": fr,
  "es": es,
  "it": it,
  "ar": ar
};

// Fill in missing translations with en-US as fallback
Object.keys(translations).forEach(lang => {
  if (lang !== "en-US") {
    translations[lang] = { ...translations["en-US"], ...translations[lang] };
  }
});

// Available languages for the language selector
export const availableLanguages = [
  { code: "en-US", name: "English (US)", flag: "🇺🇸" },
  { code: "en-GB", name: "English (UK)", flag: "🇬🇧" },
  { code: "nl", name: "Nederlands", flag: "🇳🇱" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "it", name: "Italiano", flag: "🇮🇹" },
  { code: "ar", name: "العربية", flag: "🇸🇦" }
];

// Browser language detection - maps browser language codes to our supported languages
export const detectBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  
  // Exact match first
  if (translations[browserLang]) {
    return browserLang;
  }
  
  // Try base language (e.g., "nl" from "nl-NL")
  const baseLang = browserLang.split('-')[0];
  
  // Map common browser codes to our supported languages
  const languageMap = {
    'en': 'en-US',
    'nl': 'nl',
    'de': 'de',
    'fr': 'fr',
    'es': 'es',
    'it': 'it',
    'ar': 'ar'
  };
  
  if (languageMap[baseLang]) {
    return languageMap[baseLang];
  }
  
  // Default to Dutch for this Netherlands-based taxi service
  return 'nl';
};

export default translations;
